export default "__VITE_ASSET__C2ZQEIy0__"